import { Component } from '@angular/core';
import { TranslateService } from 'ng2-translate/ng2-translate';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  constructor(translate: TranslateService) {
    translate.addLangs(['en', 'fr', 'es']);
    translate.setDefaultLang('es');

    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr|es/) ? browserLang : 'es');
  }
}



/*
#286aae

node --max_old_space_size=8192 ./node_modules/.bin/ng build --prod --base-href=/concentv2/
ng build --prod --base-href=/concentv2/
ng g service services/loginService --spec false


 ------------- STORAGES ---------------
 G13xTfsdf234TVsd23513ffdgFdf2352 ----> user
 P1I1P1O1P1E1S1345345E345345S13hZ ----> Menus
  ----> empresa
  ----> sucursal
*/


// hacer un service para ver si el tipo de usuario tiene permisos para el modulo que esta entrando
// jalando los reles del menu import { MenuItems } from '../../shared/menu-items/menu-items';
